import { createApi } from '../axios'
import { baseURL } from '../config'

function responseHandle (res) {
  let msg = ''
  if (!res.data) {
    msg = res.status
    throw new Error(msg)
  } else if (res.data.ret !== 0) {
    msg = res.data.ret + ' ' + res.data.msg
    throw new Error(msg)
  }

  return res.data
}

export default createApi(responseHandle, {
  getTaskList (params) {
    return {
      url: '/api/v1/flow_dump/get_task',
      method: 'POST',
      baseURL: baseURL,
      data: params
    }
  },
  addExportTask (params) {
    return {
      url: '/api/v1/flow_dump/add_task',
      method: 'post',
      data: params,
      baseURL: baseURL
    }
  }
})
